import React, { Component } from 'react';
import { withToastManager } from 'react-toast-notifications';
import { connect } from 'react-redux';
import _isEqual from 'lodash/isEqual';

class ToastMessage extends Component {
  constructor(props) {
    super(props);
    this.toastQueue = []; // Queue to store the toasts
    this.isDisplayingToast = false; // Flag to check if a toast is currently being displayed
    this.state = {
      isToastDisplayed: false,
    };
  }

  componentDidUpdate(prevProps) {
    const { toastManager, errors, dispatch } = this.props;
    const { isToastDisplayed } = this.state;

    if (!_isEqual(errors, prevProps.errors)) {
      errors && errors.forEach((singleError) => {
        if (singleError.useQueue) {
          // Queue the toast messages
          this.toastQueue.push(singleError);
          if (!this.isDisplayingToast) {
            this.displayNextToast(toastManager, dispatch);
          }
        } else if (singleError.controlledDisplay) {
          // Controlled display: show only one toast at a time
          const content = (
            <div>
              <strong>{singleError.heading}</strong>
              <div>{singleError.message}</div>
            </div>
          );

          if (!isToastDisplayed && singleError.message !== 'manualDismiss') {
            toastManager.add(content, {
              appearance: singleError.type || 'error',
              autoDismiss: true,
              autoDismissTimeout: 15000,
              onDismiss: () => { this.setToastDisplayed(false); },
            });
            this.setToastDisplayed(true);
          } else if (singleError.message === 'manualDismiss' && isToastDisplayed) {
            toastManager.removeAll();
            this.setToastDisplayed(false);
          }

          dispatch({
            payload: {
              error: singleError,
            },
            type: 'DISMISS_UX_CRITICAL_ERROR',
          });
        } else {
          // Display toast immediately without queue or controlled display
          const content = (
            <div>
              <strong>{singleError.heading}</strong>
              <div>{singleError.message}</div>
            </div>
          );

          toastManager.add(content, {
            appearance: singleError.type || 'error',
            autoDismiss: true,
            autoDismissTimeout: 15000,
          });

          dispatch({
            payload: {
              error: singleError,
            },
            type: 'DISMISS_UX_CRITICAL_ERROR',
          });
        }
      });
    }
  }

  displayNextToast(toastManager, dispatch) {
    if (this.toastQueue.length === 0) {
      this.isDisplayingToast = false; // No more toasts to display
      return;
    }

    this.isDisplayingToast = true;
    const singleError = this.toastQueue.shift(); // Get the next toast from the queue

    const content = (
      <div>
        <strong>{singleError.heading}</strong>
        <div>{singleError.message}</div>
      </div>
    );

    toastManager.add(content, {
      appearance: singleError.type || 'error',
      autoDismiss: true,
      autoDismissTimeout: 3000, // Display toast for 3 seconds
      onDismiss: () => {
        this.isDisplayingToast = false; // Mark the toast as dismissed
        this.displayNextToast(toastManager, dispatch); // Display the next toast in the queue
      },
    });

    dispatch({
      payload: {
        error: singleError,
      },
      type: 'DISMISS_UX_CRITICAL_ERROR',
    });
  }

  setToastDisplayed(isVisible) {
    this.setState({ isToastDisplayed: isVisible });
  }

  render() {
    return null;
  }
}

function mapStateToProps(state) {
  return {
    errors: state.app.errors,
  };
}

export default withToastManager(connect(mapStateToProps)(ToastMessage));
